import * as React from "react";
import { Context } from "./context";
export function AnalyticsEvent(_a) {
    var render = _a.render;
    return (React.createElement(Context.Consumer, null, function (track) { return render(track); }));
}



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-analytics/dist-es/consumer.js
// module id = 4pXv
// module chunks = 2